export default "/images/2c873499dbf232c77ac83bbc5b79bf66.png";